import { render } from "./DiscussionCreateView.vue?vue&type=template&id=fa7346e2"
import script from "./DiscussionCreateView.vue?vue&type=script&lang=js"
export * from "./DiscussionCreateView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__